module.exports = __webpack_public_path__ + "files/a38a4cdf20a14a7cd125e85eee888375.png";